import { render, staticRenderFns } from "./SpigotGroup.vue?vue&type=template&id=3792f15a&scoped=true&"
import script from "./SpigotGroup.vue?vue&type=script&lang=ts&"
export * from "./SpigotGroup.vue?vue&type=script&lang=ts&"
import style0 from "./SpigotGroup.vue?vue&type=style&index=0&id=3792f15a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3792f15a",
  null
  
)

export default component.exports